import { memo } from "react";
import SalesRepCallHistoryRow from "./SalesRepCallHistoryRow";
import { Table } from "react-bootstrap";

const SalesRepCallHistoryTable = ({ salesRepCalls }) => {
  return (
    <Table responsive striped bordered>
      <thead>
        <tr>
          <th>Sr No.</th>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Status</th>
          <th>Call Time</th>
          <th>Sales Representative</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        {salesRepCalls?.map((call, index) => (
          <SalesRepCallHistoryRow call={call} key={call.id} index={index + 1} />
        ))}
      </tbody>
    </Table>
  );
};

export default memo(SalesRepCallHistoryTable);
